export default __webpack_public_path__ + "static/media/flight4.b7b7586a.jpg";